import Vue from 'vue'
import VueRouter from 'vue-router'
import DashboardLayout from '../views/layout/Layout.vue'
// import Dashboard from '../views/Dashboard.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Login',
    component: () =>
      import(/* webpackChunkName: "login" */ '../views/auth/Login.vue')
  },
  {
    path: '/dashboard',
    name: 'DashboardLayout',
    component: DashboardLayout,
    children: [
      {
        path: '',
        name: 'Dashboard',
        component: () =>
          import(/* webpackChunkName: "dashboard" */ '../views/Dashboard.vue')
      },
      {
        path: 'places',
        name: 'Places',
        component: () =>
          import(/* webpackChunkName: "" */ '../views/places/Places.vue')
      },
      {
        path: 'pages',
        name: 'Pages',
        component: () =>
          import(/* webpackChunkName: "" */ '../views/pages/Pages.vue')
      },
      {
        path: 'pages/:id',
        name: 'PageProfile',
        component: () =>
          import(/* webpackChunkName: "" */ '../views/pages/PageProfile.vue')
      },
      {
        path: 'users',
        name: 'Users',
        component: () =>
          import(/* webpackChunkName: "" */ '../views/users/Users.vue')
      },
      {
        path: 'users/:id',
        name: 'UserProfile',
        component: () =>
          import(
            /* webpackChunkName: "" */ '../views/users/UserProfile.vue'
          )
      }
    ]
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
